import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { ICustomConfigurationRepository } from '../../repositories/interfaces/iCustomConfigurationRepository';
import { IBigScreenCmsMoodsResponse } from '../../../entity/interface/iBigScreenCmsMoods';

export interface IGetMoodsUseCase {
    execute(): Promise<IBigScreenCmsMoodsResponse>;
}

export class GetMoodsUseCase implements IGetMoodsUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get customConfigurationRepository(): ICustomConfigurationRepository {
        return container.resolve<ICustomConfigurationRepository>(DI.REPOSITORIES.ICustomConfigurationRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(): Promise<IBigScreenCmsMoodsResponse> {
        const response = await this.customConfigurationRepository.getMoods();
        return response;
    }
}
